import { initMapConnectionStatus, initMapProviderSettingsToggle, initMapSettingsPreview } from "../components/MapSettingsPreview";

export const AdminStoreController = {
    index(): void {},
    create(): void {
        initMapSettingsPreview();
    },
    store(): void {},
    order(): void {},
    settings(): void {
        initMapProviderSettingsToggle();
        initMapConnectionStatus();
        initMapSettingsPreview();
    },
    updateSettings(): void {},
    testConnection(): void {},
    edit(): void {
        initMapSettingsPreview();
    },
    update(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
    move(): void {},
};
